import type React from 'react';

import type { IconProps } from '../types';

export const CrossXs: React.FC<IconProps> = ({ color = 'currentColor', ...props }) => (
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.5265 3.41791C11.821 3.17764 12.2558 3.19518 12.5304 3.46967C12.805 3.74427 12.8224 4.179 12.5821 4.47358L9.06064 7.99997L12.5821 11.5264C12.8225 11.8209 12.805 12.2557 12.5304 12.5303C12.2558 12.8049 11.8211 12.8223 11.5265 12.582L8.00009 9.06052L4.53034 12.5303C4.23745 12.8232 3.76268 12.8232 3.46979 12.5303C3.17701 12.2374 3.17693 11.7626 3.46979 11.4697L6.93954 7.99997L3.41803 4.47358C3.17783 4.179 3.19522 3.74424 3.46979 3.46967C3.74435 3.1951 4.17912 3.17771 4.4737 3.41791L8.00009 6.93942L11.5265 3.41791Z"
      fill={color}
    />
  </svg>
);
